<template>
    <hts-router-drawer
        :title="$t('labels.vendorPriceModuleView')"
        size="large"
        :refresh-tables="refreshTables"
        is-close
        @loaded="getData">
        <div
            v-loading="visible"
            :style="{ minWidth: minWidthScroll }">
            <view-price-vendor :data-edit="dataEdit" />
        </div>
    </hts-router-drawer>
</template>

<script lang="ts" setup>
import { IVendorPrice } from '../ignore/data'
import ViewPriceVendor from '../-components/view-price-vendor.vue'
import { $api, $lodash, $urlSystem } from '#imports'

import screen from '~/components/utils/screen'
const { map: mapStore } = $store()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const { $disableReactive } = useNuxtApp()

const emits = defineEmits(['refreshTables'])

const visible = ref(false)
const priceVendorId = computed(() => useRoute().params.cooperatorId)

const getData = () => {
  mapStore.setShowLocation({ priceVendor: false })

  visible.value = true

  if (priceVendorId.value) {
    const api = $url.price.vendor.get

    $api(api, { uriParams: { ID: priceVendorId.value || '' } }).then((data) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        Object.assign(dataEdit.value, { ...resData.data })

        if (dataEdit.value.vendor && typeof dataEdit.value.vendor !== 'string') {
          dataEdit.value.vendorName = dataEdit.value.vendor.name
          dataEdit.value.vendor = dataEdit.value.vendor._id
        }

        if (dataEdit.value.contact && typeof dataEdit.value.contact !== 'string') {
          dataEdit.value.email = dataEdit.value.contact?.email
          dataEdit.value.phone = dataEdit.value.contact?.phone
          dataEdit.value.contactName = dataEdit.value.contact?.fullName
          dataEdit.value.contact = dataEdit.value.contact?._id
        }

        dataWorkflow.value.positions = resData.data.positions

        visible.value = false
      }
    })
  }
}

const init: IVendorPrice = {
  createPriceFrom: 1,
  quote: null,
  quoteCode: null,
  quoteRequest: null,
  quoteRequestCode: null,
  vendor: null,
  contact: null,
  contactName: '',
  vendorName: '',
  email: null,
  phone: null,
  workflow: null,
  workflowName: '',
  transportation: '',
  contCategory: '',
  vehicleCategory: '',
  effectiveFromDate: null,
  effectiveToDate: null,
  price: null,
  oilPrice: null,
  description: null,
  mergeContainer: false,
  headContainer: false,
  positions: [],
  theSamePositions: [],
  typeCommodity: [],
  vehicleCategoryName: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: ''
    }
  ],
  priceOfflineFee: []
}

const dataEdit = ref<IVendorPrice>({
  createPriceFrom: 1,
  quote: null,
  quoteCode: null,
  quoteRequest: null,
  quoteRequestCode: null,
  vendor: null,
  contact: null,
  contactName: '',
  vendorName: '',
  email: null,
  phone: null,
  workflow: null,
  workflowName: '',
  transportation: '',
  contCategory: '',
  vehicleCategory: '',
  effectiveFromDate: null,
  effectiveToDate: null,
  price: null,
  oilPrice: null,
  description: null,
  mergeContainer: false,
  headContainer: false,
  positions: [],
  theSamePositions: [],
  typeCommodity: [],
  vehicleCategoryName: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: ''
    }
  ],
  priceOfflineFee: []
})

const popover = ref()

const dataWorkflow = ref<{ [key: string]: any }>([])

const handleSubmit = async () => {
  const api = $url.price.vendor.update

  const data: any = await $api(api, {
    uriParams: { ID: dataEdit.value?._id || '' },
    body: dataEdit.value
  })
  const resData: any = data?.data?.value

  if (resData && resData.success) {
    process.client && $toast().success($t('labels.updateSuccess'))
    emits('refreshTables')
    getData()
  }
}
const getNodeTheSamePosition = (index: number, data: Array<Array<number>>) => {
  if (typeof index !== 'number' || !Array.isArray(data)) {
    return
  }
  let result: Array<number> = []
  const filteredItems = data.filter((i: Array<number>) => i.includes(index))
  const tempData = data.filter((i: Array<number>) => !i.includes(index))
  filteredItems.forEach((item) => {
    if (!Array.isArray(item) || item.length !== 2) {
      return
    }
    const tempIndex = item.findIndex((o) => o === index)
    let tempIndex2
    if (tempIndex === 0) {
      tempIndex2 = 1
    } else {
      tempIndex2 = 0
    }

    result.push(item[1])
    result.push(item[0])

    const itemNodeTheSames: Array<number> | undefined = getNodeTheSamePosition(item[tempIndex2], tempData)
    if (Array.isArray(itemNodeTheSames)) {
      result = result.concat(itemNodeTheSames)
    }
  })
  return $lodash.uniq(result)
}
const mapPosition = ref()

const openWithMap = () => {
  mapPosition.value && mapPosition.value.open($disableReactive(dataEdit.value.positions), $disableReactive(dataEdit.value.theSamePositions))
}
const typeCommodity = [
  {
    key: 'NORMAL',
    title: $t('labels.ordinaryGoods')
  },
  {
    key: 'LIQUID',
    title: $t('labels.liquid')
  },
  {
    key: 'GAS',
    title: $t('labels.gas')
  },
  {
    key: 'FROZEN',
    title: $t('labels.frozen')
  },
  {
    key: 'DANGEROUS',
    title: $t('labels.dangerousGoods')
  },
  {
    key: 'FRAGILE',
    title: $t('labels.fragileGoods')
  },
  {
    key: 'OVERWEIGHT',
    title: $t('labels.overweightCargo')
  }
]
const refreshTables = () => {
  emits('refreshTables')
}
</script>
